import { useLocation, Link } from "react-router-dom";
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16 md:pt-28 md:pb-24 bg-background-50 min-h-[60vh] flex items-center justify-center">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
          <div className="mb-6">
            <div className="w-20 h-20 rounded-2xl bg-background-200 flex items-center justify-center mx-auto mb-6">
              <i className="ri-error-warning-line text-foreground-300 text-4xl"></i>
            </div>
            <h1 className="font-heading font-extrabold text-6xl md:text-8xl text-background-200 select-none pointer-events-none mb-2">
              404
            </h1>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-800 mt-2">
              Page Not Found
            </h2>
          </div>
          <p className="text-foreground-400 mb-2 font-mono text-sm">
            {location.pathname}
          </p>
          <p className="text-foreground-500 mb-8 max-w-md mx-auto">
            The page you are looking for does not exist or has been moved. Return to the homepage to continue exploring VigorBuy Spreadsheet resources.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}